export default "__VITE_ASSET__Cw3p$LpU__"